import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import axios, { API, authHeaders, errText } from '../api';
import Layout from './Layout';
import CalendarGrid, { STATUS_STYLE } from '../components/CalendarGrid';
import Modal from '../components/Modal';
import { ui } from '../ui';
import { colors } from '../theme';

export default function Slots() {
  const navigate = useNavigate();
  const [slots, setSlots] = useState([]);
  const [weekOffset, setWeekOffset] = useState(0);
  const [selected, setSelected] = useState(null);
  const [error, setError] = useState('');

  const [date, setDate] = useState('');
  const [startTime, setStartTime] = useState('12:00');
  const [endTime, setEndTime] = useState('14:00');
  const [creating, setCreating] = useState(false);

  const fetchSlots = useCallback(() => {
    axios.get(`${API}/curator/slots`, { headers: authHeaders() }).then(r => setSlots(r.data));
  }, []);
  useEffect(() => { fetchSlots(); }, [fetchSlots]);

  const openAvailability = async () => {
    if (!date || !startTime || !endTime) return;
    setError('');
    setCreating(true);
    try {
      const startAt = new Date(`${date}T${startTime}:00`).toISOString();
      const endAt = new Date(`${date}T${endTime}:00`).toISOString();
      await axios.post(`${API}/curator/availability`, { start_at: startAt, end_at: endAt }, { headers: authHeaders() });
      fetchSlots();
    } catch (e) {
      setError(errText(e, 'Не удалось открыть период'));
    }
    setCreating(false);
  };

  const cancelSlot = async (slot) => {
    await axios.delete(`${API}/curator/slots/${slot.id}`, { headers: authHeaders() });
    setSelected(null);
    fetchSlots();
  };

  const markNoShow = async (slot) => {
    if (!window.confirm('Отметить неявку по этому слоту?')) return;
    await axios.post(`${API}/curator/slots/${slot.id}/no-show`, {}, { headers: authHeaders() });
    setSelected(null);
    fetchSlots();
  };

  const reopenSlot = async (slot) => {
    await axios.post(`${API}/curator/slots/${slot.id}/reopen`, {}, { headers: authHeaders() });
    setSelected(null);
    fetchSlots();
  };

  const goToClient = (slot) => navigate(`/clients?open=${slot.user_id}`);

  return (
    <Layout>
      <h1 style={ui.title}>Слоты интервью</h1>

      <div style={ui.card}>
        <div style={{ fontWeight: 600, marginBottom: 12 }}>Открыть период — разобьётся на слоты по 20 минут</div>
        <div style={ui.row}>
          <input style={ui.input} type="date" value={date} onChange={e => setDate(e.target.value)} />
          <input style={ui.input} type="time" value={startTime} onChange={e => setStartTime(e.target.value)} />
          <span style={{ color: colors.textMuted }}>—</span>
          <input style={ui.input} type="time" value={endTime} onChange={e => setEndTime(e.target.value)} />
          <button style={ui.btn} onClick={openAvailability} disabled={creating}>{creating ? 'Открываем…' : 'Открыть период'}</button>
        </div>
        {error && <div style={ui.error}>{error}</div>}
      </div>

      <CalendarGrid slots={slots} weekOffset={weekOffset} onWeekChange={setWeekOffset} onSlotClick={setSelected} />

      {selected && (
        <Modal onClose={() => setSelected(null)}>
          <div style={{ fontWeight: 600, marginBottom: 8 }}>
            {new Date(selected.start_at).toLocaleString('ru', { weekday: 'long', day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}
            {' · '}{STATUS_STYLE[selected.status]?.label || selected.status}
          </div>
          {selected.user_name && (
            <div style={{ fontSize: 14, marginBottom: 4 }}>Клиент: {selected.user_name} ({selected.user_phone})</div>
          )}
          {selected.user_id && (
            <button style={{ ...ui.btnSecondary, marginBottom: 12 }} onClick={() => goToClient(selected)}>Перейти в анкету →</button>
          )}
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: selected.user_id ? 0 : 12 }}>
            {selected.status === 'open' && <button style={ui.btnDanger} onClick={() => cancelSlot(selected)}>Отменить слот</button>}
            {selected.status === 'cancelled' && <button style={ui.btnSecondary} onClick={() => reopenSlot(selected)}>Вернуть в открытые</button>}
            {selected.status === 'booked' && <button style={ui.btnSecondary} onClick={() => markNoShow(selected)}>Отметить неявку</button>}
            <button style={ui.btnSecondary} onClick={() => setSelected(null)}>Закрыть</button>
          </div>
        </Modal>
      )}
    </Layout>
  );
}
